import Request from 'utils/request.js';

const BASE_URL = '/management/settings';

export const getSettings = () => Request.get(`${BASE_URL}`);
export const saveSetting = (data) => Request.post(`${BASE_URL}`, data);
